import i18n from "i18next";
import translationEng from "./locale/en/translation.json";

i18n.init({
    debug: false,
    lng: "en",
    interpolation: {
        escapeValue: false // react already safes from xss
    },
    resources: {
        en: {
            translations: translationEng
        },
    },
    ns: ["translations"],
    defaultNS: "translations"
});

export default i18n;